// Node environment (isProd=True on Staging )
const env = process.env.NODE_ENV || "development";
const isDev = env === "development";
const isProd = env === "production";
const isTest = env === "test";

// HUG Environment
const isStaging = process.env.REACT_APP_API_URL?.includes("thesecrethug.xyz");

// Feature flags
const featureFlags = {
  // Catch outgoing requests with MSW or pass through to actual API_URL, only in DEV
  enableAPIMocking: !isProd && false,
  // Require staging password authentication to entire site
  enableStagingAuth: !!process.env.REACT_APP_SHOW_PASSWORD,
  // Show React-Query developer tool icon in bottom-left corner
  enableQueryDevTools: isDev,
  // Show interactive elements on project card components
  enableProjectInteractions: true,
  // Show follow button for project cards
  enableProjectFollow: false,
  // Show the section with trending tags, top curators and stats
  enableTrendingSection: true,
  // Show the section at the bottom "Keep Exploring"
  enableKeepExploring: false,
  // Show my reviews on profile page
  enableProfileMyReviews: true,
  // Allow 1/1 for Search Results
  enableOneSlashOne: isStaging || isDev,
  // Allow Rewards Wallet Connect
  enableRewardsWallet: isStaging || isDev,
  // Show Notifications Top Menu
  enableNotificationsMenu: true,
  // Show dynamic home page
  enableDynamicHomePage: false,
};

// Constants
const constants = {
  // API and WebSocket URLs
  apiUrl: process.env.REACT_APP_API_URL ?? "",
  wsUrl: process.env.REACT_APP_WS_URL ?? "",
  // Time to reconnect after drop
  wsTimeout: 1000 * 30,

  // Staging Access cookie details
  stagingPreviewKey: "HUG_STAGING_PREVIEW",
  stagingPreviewAge: 60 * 60 * 24 * 7,

  // Application Links
  groupHugApplication: "https://thehugxyz.typeform.com/grouphug0003",
  hedgeHugApplication: "https://thehugxyz.typeform.com/hedgehug",

  // Social Links
  twitterURL: "https://twitter.com/thehugxyz",
  discordURL: "https://discord.gg/thehugxyz",
  mediumArticle:
    "https://medium.com/@thehugxyz/hug-it-out-with-us-2ae5a97b1d3c",
  openseaURL: "https://opensea.io/collection/hugpass",

  // Web3
  alchemyUrl: process.env.REACT_APP_ALCHEMY_URL ?? "",
  chainId: 1,
  contractAddress: process.env.REACT_APP_CONTRACT_ADDRESS ?? "",
  etherscanURL: "https://etherscan.io",

  // Oauth
  discordConnectUrl: process.env.REACT_APP_DISCORD_CONNECT_URL ?? "",

  // Studio Applications
  applicationsOpen: false,
  applyStartDate: "August 8",
  applyEndDate: "August 29",
  applyUrl: "https://hugapp.paperform.co/",

  // Points required to earn roles
  pointsRequiredLevel2: 1500,
  pointsRequiredLevel3: 2500,

  // Points Earned
  pointsEarnedBecomeReviewer: 250,
  pointsEarnedBecomeModerator: 250,
  pointsEarnedBecomeCurator: 250,
  pointsEarnedReviewApproved: 100,
  pointsEarnedReviewApprovedFirst50: 150,
  pointsEarnedModeratorVote: 30,
  pointsEarnedDailySignin: 10,

  // Points Staked
  pointsStakedReview: 50,
};

export { env, isDev, isProd, isTest, isStaging, featureFlags, constants };
